module.exports = __webpack_public_path__ + "img/cy.695be673.svg";